export function formatNumber(num: number | string): string {
  var parsed = parseFloat(num as string);
  if (isNaN(parsed)) return "0.00";

  var parts = num.toString().split(".");
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
}

export function formatAmount(amount: number, currency: string | null = null, options: { showCurrency?: boolean } = { showCurrency: false }) {
  if (currency && options.showCurrency) return new Intl.NumberFormat("en-IN", { minimumSignificantDigits: 2, style: "currency", currency }).format(amount);

  return formatNumber(typeof amount === "string" ? parseFloat(amount).toFixed(2) : amount.toFixed(2));
}

export function formatCost(
  cost: number | null,
  currency: string | null = null,
  options: { deviceActivation?: boolean; showCurrency?: boolean } = { deviceActivation: false, showCurrency: true }
) {
  if (options.deviceActivation) return cost == null || cost === 0 || isNaN(cost) ? "0.00" : formatAmount(cost, currency, { showCurrency: options.showCurrency });
  else return cost == null || cost === 0 ? "FREE" : formatAmount(cost, currency, { showCurrency: options.showCurrency });
}

export function formatRate(
  rate: number | null,
  unit = "h",
  currency: string | null = null,
  options: { deviceActivation?: boolean; showCurrency?: boolean } = { deviceActivation: false, showCurrency: true }
) {
  const unitText = unit ? ` / ${unit}` : "";
  if (options.deviceActivation)
    return rate == null || rate === 0 || isNaN(rate) ? `0.00${unitText}` : formatAmount(rate, currency, { showCurrency: options.showCurrency }) + unitText;
  else return rate == null || rate === 0 || isNaN(rate) ? `FREE` : formatAmount(rate, currency, { showCurrency: options.showCurrency }) + unitText;
}

export function formatDecimal(value: any) {
  return parseFloat(value || "0").toFixed(2);
}

export function stringToDecimal(string, decimalPlaces = 2) {
  if (!string) return "0.00";
  return parseFloat(string).toFixed(decimalPlaces);
}

export function floorNumberToTwoDecimal(number) {
  if (!number) return 0.0;
  return Math.floor(number * 100) / 100;
}

// Basically usd/wh = 1000 * usd/kwh
// We need to multiply by 1_000_000_000 to handle javascript weird number division, check https://stackoverflow.com/questions/5037839/avoiding-problems-with-javascripts-weird-decimal-calculations
export function formatConsumptionRate(
  rate: any,
  currency: string | null = null,
  options: { deviceActivation?: boolean; showCurrency?: boolean } = { deviceActivation: false, showCurrency: true }
) {
  rate = parseFloat(rate || "0");
  const value = (rate * 1_000_000_000) / 1_000_000;

  if (options.deviceActivation) {
    return rate === 0 || isNaN(rate) ? "0.00" + " / kWh" : formatAmount(value, currency, { showCurrency: options.showCurrency }) + " / kWh";
  } else return rate === 0 || isNaN(rate) ? "FREE" : formatAmount(value, currency, { showCurrency: options.showCurrency }) + " / kWh";
}
